'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _BaseApi = require('../BaseApi');
var _BaseApi2 = _interopRequireDefault(_BaseApi);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var EmbedApi = function () {
  function EmbedApi() {
    (0, _classCallCheck3.default)(this, EmbedApi);
    this.apiService = new _BaseApi2.default(_frontendUtils.endpoints.apiBaseUrl);
  }
  (0, _createClass3.default)(EmbedApi, [{
    key: 'getLookerEmbed',
    value: function getLookerEmbed(embedContext, embedType, embedId) {
      if (!ValidationUtils.isString(embedContext)) {
        return Promise.reject(new _ParameterError2.default('embedContext', embedContext, 'must be a string.'));
      }
      if (!ValidationUtils.isString(embedType)) {
        return Promise.reject(new _ParameterError2.default('embedType', embedType, 'must be a string.'));
      }
      if (!ValidationUtils.isNumber(embedId)) {
        return Promise.reject(new _ParameterError2.default('embedId', embedId, 'must be a number.'));
      }
      return this.apiService.makeRequest({
        method: 'GET',
        url: 'maestro/insights/embed/' + embedContext + '/' + embedType + '/' + embedId
      });
    }
  }, {
    key: 'getDashboardsForSpace',
    value: function getDashboardsForSpace(spaceId) {
      if (!ValidationUtils.isString(spaceId)) {
        return Promise.reject(new _ParameterError2.default('spaceId', spaceId, 'must be a string.'));
      }
      return this.apiService.makeRequest({
        method: 'GET',
        url: 'maestro/insights/dashboards/space/' + spaceId
      });
    }
  }, {
    key: 'getLooksForSpace',
    value: function getLooksForSpace(spaceId) {
      if (!ValidationUtils.isString(spaceId)) {
        return Promise.reject(new _ParameterError2.default('spaceId', spaceId, 'must be a string.'));
      }
      return this.apiService.makeRequest({
        method: 'GET',
        url: 'maestro/insights/looks/space/' + spaceId
      });
    }
  }, {
    key: 'getDashboardsForCurrentUser',
    value: function getDashboardsForCurrentUser() {
      return this.apiService.makeRequest({
        method: 'GET',
        url: 'maestro/insights/dashboards/currentUser'
      });
    }
  }]);
  return EmbedApi;
}();
exports.default = EmbedApi;